import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {reducer} from './store/reducers';
import {EffectsModule} from '@ngrx/effects';
import {LoadingIndicatorEffects} from './store/effects/loading-indicator.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('loading', reducer),
    EffectsModule.forFeature([LoadingIndicatorEffects])
  ]
})
export class LoadingIndicatorModule { }
